import { Instance } from 'mobx-state-tree';
import { ScheduleActionIgnoredFeaturesDtoModelBase } from './ScheduleActionIgnoredFeaturesDtoModel.base';

/* The TypeScript type of an instance of ScheduleActionIgnoredFeaturesDtoModel */
export interface ScheduleActionIgnoredFeaturesDtoModelType extends Instance<typeof ScheduleActionIgnoredFeaturesDtoModel.Type> {}

/* A graphql query fragment builders for ScheduleActionIgnoredFeaturesDtoModel */
export { selectFromScheduleActionIgnoredFeaturesDto, scheduleActionIgnoredFeaturesDtoModelPrimitives, ScheduleActionIgnoredFeaturesDtoModelSelector } from './ScheduleActionIgnoredFeaturesDtoModel.base';

/**
 * ScheduleActionIgnoredFeaturesDtoModel
 */
export const ScheduleActionIgnoredFeaturesDtoModel = ScheduleActionIgnoredFeaturesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
